import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';

const PortletHeader = props => {
  const { className, noDivider, noPadding, children, sx, ...rest } = props;
  const theme = useTheme();

  const rootStyling = {
    alignItems: 'center',
    borderBottom: noDivider ? 'none' : `1px solid ${theme.palette.border}`,
    borderTopLeftRadius: '2px',
    borderTopRightRadius: '2px',
    display: 'flex',
    height: '64px',
    justifyContent: 'space-between',
    paddingLeft: noPadding ? 0 : theme.spacing(3),
    paddingRight: noPadding ? 0 : theme.spacing(3),
    position: 'relative',
  };
  return (
    <Box {...rest} sx={[rootStyling, ...(Array.isArray(sx) ? sx : [sx])]} className={className}>
      {children}
    </Box>
  );
};

PortletHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  noDivider: PropTypes.bool,
  noPadding: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
};

PortletHeader.defaultProps = {
  children: undefined,
  className: 'portlet-header',
  noDivider: false,
  noPadding: false,
  sx: undefined,
};

export default PortletHeader;
